import { useHeaderState } from "@faire/retailer-visitor-shared/components/Header/useHeaderState";
import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { SignUpElement, SignUpSource, SignUpType, usePopSignUp } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { blogPage } from "@faire/retailer-visitor-shared/paths/index";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { useLocalization } from "@faire/web--source/common/localization/useLocalization";
import { useCurrentPath } from "@faire/web--source/ui/hooks/useCurrentPath";
import { trackFaireDirectShoppableLandingPageNavSignUpClick } from "@faire/web-api--source/events/faireDirect/click/shoppableLandingPageNavSignUp";
import { trackSignupSignUpToShopButtonClick } from "@faire/web-api--source/events/signup/click/signUpToShopButton";
import { route as supportRoute } from "@faire/web-api--source/routes/www/support";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
var SIGN_IN_QUERY_PARAM = "signIn";
export var useNavigateAndHideMenu = function() {
    var history = useHistory();
    var path = useCurrentPath();
    var isFaireDirectActiveInLoggedOut = useFaireDirectBrand().isFaireDirectActiveInLoggedOut;
    var popSignUp = usePopSignUp().popSignUp;
    var _useLocalization = useLocalization(), locale = _useLocalization.intl.locale;
    var hideMenu = useHeaderState().hideMenu;
    var navigateTo = useCallback(function(path) {
        history.push(path);
        hideMenu();
    }, [
        hideMenu,
        history
    ]);
    var navigateToHelpCenter = useCallback(function() {
        var _getWindowOrThrow;
        (_getWindowOrThrow = getWindowOrThrow()) === null || _getWindowOrThrow === void 0 ? void 0 : _getWindowOrThrow.open(supportRoute, "_blank");
        hideMenu();
    }, [
        hideMenu
    ]);
    var navigateToBlog = useCallback(function() {
        var _getWindowOrThrow;
        (_getWindowOrThrow = getWindowOrThrow()) === null || _getWindowOrThrow === void 0 ? void 0 : _getWindowOrThrow.open(blogPage(locale), "_blank");
        hideMenu();
    }, [
        hideMenu,
        locale
    ]);
    var navigateToSignUp = useCallback(function(ev, trackingParams) {
        ev === null || ev === void 0 ? void 0 : ev.preventDefault();
        var trackingFunction = isFaireDirectActiveInLoggedOut ? trackFaireDirectShoppableLandingPageNavSignUpClick : trackSignupSignUpToShopButtonClick;
        var _trackingParams_element, _trackingParams_sourceId;
        popSignUp(SignUpType.GENERIC, trackingFunction, {
            element: SignUpElement[(_trackingParams_element = trackingParams === null || trackingParams === void 0 ? void 0 : trackingParams.element) !== null && _trackingParams_element !== void 0 ? _trackingParams_element : SignUpElement.CATNAV],
            sourceId: (_trackingParams_sourceId = trackingParams === null || trackingParams === void 0 ? void 0 : trackingParams.sourceId) !== null && _trackingParams_sourceId !== void 0 ? _trackingParams_sourceId : SignUpSource.CATNAV_SIGNUP_CTA
        });
        hideMenu();
    }, [
        hideMenu,
        isFaireDirectActiveInLoggedOut,
        popSignUp
    ]);
    var navigateToFaireMarketSignUp = useCallback(function(trackingParams) {
        var _trackingParams_element, _trackingParams_sourceId;
        popSignUp(SignUpType.GENERIC, function() {
            return null;
        }, {
            element: SignUpElement[(_trackingParams_element = trackingParams === null || trackingParams === void 0 ? void 0 : trackingParams.element) !== null && _trackingParams_element !== void 0 ? _trackingParams_element : SignUpElement.CATNAV],
            sourceId: (_trackingParams_sourceId = trackingParams === null || trackingParams === void 0 ? void 0 : trackingParams.sourceId) !== null && _trackingParams_sourceId !== void 0 ? _trackingParams_sourceId : SignUpSource.FAIRE_MARKET_SIGNUP_CTA
        }, {
            faireMarket: "1"
        });
        hideMenu();
    }, [
        hideMenu,
        popSignUp
    ]);
    var navigateToSignIn = useCallback(function(redirectTo) {
        if (path.searchParams.get(SIGN_IN_QUERY_PARAM)) {
            return;
        }
        history.replace(path.append({
            signIn: "1",
            redirectTo: redirectTo
        }).toString());
        hideMenu();
    }, [
        hideMenu,
        history,
        path
    ]);
    return {
        navigateToBlog: navigateToBlog,
        navigateToSignUp: navigateToSignUp,
        navigateToFaireMarketSignUp: navigateToFaireMarketSignUp,
        navigateToSignIn: navigateToSignIn,
        navigateTo: navigateTo,
        navigateToHelpCenter: navigateToHelpCenter
    };
};
